module.exports = __webpack_public_path__ + "static/media/TenantIconHomeCTA.592544a2.svg";